import { checkSicoobAccount } from "@/utils/CheckSicoobAccount";

export const bankAccountNumberValidation = (
  value: string,
  values: Record<string, string>[]
) => {
  const bankNumber = values[0]?.bankNumber;

  type BankValidationRule = {
    validation: (value: string) => boolean;
  };

  const bankValidationRules: Record<string, BankValidationRule> = {
    // sicoob
    "756": {
      validation: (value: string): boolean => checkSicoobAccount(value)
    }
  };

  const foundBankValidation = bankValidationRules[bankNumber];

  if (foundBankValidation) {
    const isValid = foundBankValidation.validation(value);

    if (!isValid) {
      return { success: false, message: "Conta Inválida" };
    }
  }

  return { success: true, message: null };
};
